/* eslint-disable react/no-danger */

import H from '@zola/zola-ui/src/typography/Headings';

import { ContentItemType } from '../../types/seoTypes';

import styles from './seoContent.module.less';

interface SeoContentProps {
  heading?: React.ReactNode;
  contentItems?: ContentItemType[];
}
const SeoContent: React.FC<SeoContentProps> = ({ heading, contentItems = [] }) => {
  if (contentItems.length === 0) {
    return null;
  }

  return (
    <div className={styles.seoContent}>
      <H.Title2 presentation="h3">{heading}</H.Title2>
      {contentItems.map((item, index) => {
        return (
          <section key={`item-${index}`} className={styles.seoEntry}>
            <H.Title3 presentation="h4">{item.heading}</H.Title3>
            <div
              className={styles.seoContentBlock}
              dangerouslySetInnerHTML={{ __html: item.htmlContent }}
            />
          </section>
        );
      })}
    </div>
  );
};

export default SeoContent;
